import React, { Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
const Header = React.lazy(() => import('./header/Header'));
const Footer = React.lazy(() => import('./footer/Footer'));
const ChatHome = React.lazy(() => import('./chat/ChatHome'));
const Portfolio = React.lazy(() => import('./portfolio/Portfolio'));
const About = React.lazy(() => import('./about/About'));

function App() {
  const location = useLocation();
  const isChatHome = location.pathname === '/';

  return (
    <>
      <Header />

      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<ChatHome />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </Suspense>

      {/* The chat home is a full-viewport experience, so the global footer is
          hidden there and shown on the content pages. */}
      {!isChatHome && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}
    </>
  );
}

export default App;
